import React from "react";
// import Crdd
import logo from ".././assets/img/logo2.png";

const CopyRight = () => {
    return (
        <>
            <div className="copyright_area bg-white border-t-2">
                <div className="container text-[12px] flex justify-between items-center text-white">
                    <div className="copyright_left font-sm">
                        Copyright © 2024 All Rights Reserved
                    </div>

                    <div className="copyright_right text-end">
                        <img src={logo} className="h-12" alt="img" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default CopyRight;
